import React from 'react';
import { Box } from '@sparknz/spark-pattern-library';

import { StoreItemViewModel } from 'shared/types/store';
import { InStockPill, OutStockPill } from '../../../../StoreListSection.styles';

type StoreStockBoxProps = {
  store: StoreItemViewModel;
};

const StoreStockBox = ({ store }: StoreStockBoxProps) => {
  return (
    <Box
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="flex-start"
      py="s2"
      px="s2"
    >
      {store.stockStatus === 'IN_STOCK' ? (
        <InStockPill variant="footnoteMedium">In stock</InStockPill>
      ) : (
        <OutStockPill variant="footnoteMedium">Out of stock</OutStockPill>
      )}
    </Box>
  );
};

export default StoreStockBox;
